// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ProfileMainSec_Wrapper__2aqpA","LeftSec":"ProfileMainSec_LeftSec__rUlOA","RightSec":"ProfileMainSec_RightSec__3Zs-Q"};